var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ratio ratio-16x9"},[_c('iframe',{staticClass:"embed-responsive-item",attrs:{"src":_vm.url,"loading":"lazy","allow":"accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;","allowfullscreen":"true"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }